// extracted by mini-css-extract-plugin
export default {"purch":"Purchases_purch__etPkb","decorWrapper":"Purchases_decorWrapper__VQcHg"};